export enum LogLevel {
    TRACE,
    DEBUG,
    INFORMATION,
    WARNING,
    ERROR,
    CRITICAL,
    NONE
}

export type LogReqModel={
    personId : number,
    onlinePaymentId : string,
    logLevel : LogLevel,
    message : string
}